<template>
    <svg
      :width="size || 26"
      :height="size ? size * 15 / 26 : 15"
      viewBox="0 0 36 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :class="className"
    >
      <title>Email</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Social-Icons---Isolated"
          transform="translate(-394.000000, -1411.000000)"
          :fill="color || '#777e90'"
        >
          <path
            d="M394,1413.16232 L394,1433.54761 C394,1434.65665 394.811742,1435.55548 395.930065,1435.55548 L427.744774,1435.55548 C428.861935,1435.55548 429.674839,1434.64619 429.674839,1433.54761 L429.674839,1413.16232 C429.674839,1411.94529 428.947871,1411 427.744774,1411 L395.930065,1411 C394.680516,1411 394,1411.96852 394,1413.16232 M396.933419,1414.93794 C396.933419,1414.44671 397.23071,1414.16568 397.705677,1414.16568 C397.999484,1414.16568 409.560129,1421.4911 410.260387,1421.92077 L412.069677,1423.04606 C412.643355,1422.66168 413.219355,1422.33303 413.813935,1421.93471 C415.027484,1421.15897 425.825161,1414.16568 426.122452,1414.16568 C426.598581,1414.16568 426.89471,1414.44671 426.89471,1414.93794 C426.89471,1415.45819 425.892516,1415.97497 425.239871,1416.37329 C421.139355,1418.87239 417.04,1421.59677 412.980129,1424.18877 C412.743226,1424.34903 412.284516,1424.69161 411.940774,1424.63935 C411.557548,1424.58013 399.793677,1417.02245 397.653419,1415.76361 C397.331742,1415.57432 396.933419,1415.40129 396.933419,1414.93794"
            id="Email"
          ></path>
        </g>
      </g>
    </svg>
  </template>
  
  <script>
  export default {
    name: "IconEmail",
    props: {
      color: {
        type: String,
        default: "#777e90"
      },
      className: {
        type: String,
        default: ""
      },
      size: {
        type: Number,
        default: 26
      }
    }
  };
  </script>
  